module.exports = __webpack_public_path__ + "img/Stop_War_HD 2_00063.abb8ce96.png";